import API from '@/utils/api'

export const authApi = {
  login: (username, password, fingerprintData, turnstileToken) =>
    API.postLoginData(username, password, fingerprintData, turnstileToken),

  facebookLogin: (userID, accessToken, fingerprintData) =>
    API.postFacebookLogin(userID, accessToken, fingerprintData),

  register: (data) => API.postRegister(data),

  facebookRegister: (data) => API.postFacebookRegister(data),

  logout: () => API.postLogoutData(),

  fetchUser: () => API.fetchUserData(),

  recoverPassword: (email) => API.postRecoverPass(email),

  resetPassword: (token, data) => API.postResetPassword(token, data),

  closeAllSessions: (token) => API.closeAllSessions(token),

  requestSms: (smsData) => API.requestSms(smsData),

  verifySms: (smsData) => API.verifySms(smsData),

  checkOtherSessions: () => API.checkOtherSessionsUser(),

  getActiveSessions: (tmpToken) => API.getActiveSessions(tmpToken),

  reactivateSession: (tmpToken) => API.reactivateCurrentSession(tmpToken),
}
